import { Box, Grid, Container } from '@mui/material';
import OverView from './Components/Overview';
import CurrentScreen from './Components/CurrentScreen';
import { ToastContainer } from 'react-toastify';

const CreateCourse = () => (
    <Container maxWidth="xl" sx={{ my: 4 }}>
        <Grid container spacing={4} alignItems="stretch">
            <Grid item lg={3.5} md={4} sm={12} xs={12}>
                <Box height="100%">
                    <OverView />
                </Box>
            </Grid>
            <Grid
                item
                lg={8.5}
                md={8}
                sm={12}
                xs={12}
                height="100%"
                minHeight="calc(100vh - 95px)"
            >
                <Box display="flex" flexDirection="column" gap={1}>
                    <CurrentScreen />
                </Box>
            </Grid>
        </Grid>
        <ToastContainer />
    </Container>
);

export default CreateCourse;
